<template>
  <section>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <HeaderSmall :pageTitle="pageData.title" />
    <div class="container">
    <section class="section m-y-xl">
      <div class="columns">
        <div class="column">

          <div class="content">
            <div v-html="$marked(pageData.content)"></div>
          </div>

        <vue-friendly-iframe className="pp-bt" src="https://sloboziabc.org/api/paypall_monthly.html"></vue-friendly-iframe>


        </div>
      </div>
    </section>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import HeaderSmall from "@/components/HeaderSmall.vue";
export default {
  name: "Donations",
  components: {
    HeaderSmall
  },
  data() {
    return {
      isLoading: false,
      pageData: {
        content:""
      },
      trans:{
        en: {
          title: "Donations",
          description: "Every little support matters!"     
          },
        ru: {
          title: "Пожертвования",
          description: "Любая ваша помощь имеет значение!",
         },
      },
      hasMeta: {
        title: "Donations",
        description: "Every little support matters!"  
      }
    };
  },
  methods:{
    loadPageData() {
      let getFrom = this.lang+"-donate";
      this.isLoading = true;
      this.axios
        .get(getFrom)
        .then(response => {
          this.isLoading = false;
          if (response.data.id) {
            this.pageData = response.data;
          } else {
            console.log("Error getting data");
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    doMeta(){
      if(this.lang){
        this.hasMeta.title = this.trans[this.lang].title;
        this.hasMeta.description = this.trans[this.lang].description;
      }
    }
  },
  mounted() {
    this.loadPageData();
    this.doMeta();
  },
  computed: {
    ...mapState(["lang"]),
  },
  watch:{
    lang: function () {
      this.loadPageData();
      this.doMeta();
    }
  },
   metaInfo() {
    return {
      title: this.$mySite.title,
      titleTemplate: this.hasMeta.title + " | %s",
      htmlAttrs: {
        lang: this.lang
      },
      meta: [
        {
          name: "description",
          content: this.hasMeta.description
        },
        {
          property: "og:title",
          content: this.$mySite.title,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.hasMeta.description,
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: this.$mySite.image,
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: this.$mySite.url,
          vmid: "og:url"
        }
      ]
    };
  } //end meta
}
</script>
<style scoped>
.pp-bt{
  width: 200px!important;
  height: 80px!important;
  overflow: hidden;
  display: block;
  border: none;
}
</style>
